import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBuildingOffice = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M2.5 14H13.5M3 2H13M3.5 2V14M12.5 2V14M6 4.5H7M6 6.5H7M6 8.5H7M9 4.5H10M9 6.5H10M9 8.5H10M6 14V11.75C6 11.3358 6.33579 11 6.75 11H9.25C9.66421 11 10 11.3358 10 11.75V14",
		stroke: "currentcolor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgBuildingOffice;
